class GA4Provider {
  constructor() {
    this.GTM_ID = window.GTM_ID
    this.initializeGA4()
  }

  initializeGA4() {
    console.log('Initializing GA4 analytics')
    ;(function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })
      const f = d.getElementsByTagName(s)[0]
      const j = d.createElement(s)
      const dl = l !== 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', this.GTM_ID)
    window.dataLayer = window.dataLayer || []
  }

  track(eventName, eventData) {
    window.dataLayer.push({
      event: eventName,
      eventData
    })

    this.dispatchCustomEvent(eventName, eventData)
  }

  dispatchCustomEvent(eventName, eventData) {
    console.log('Dispatching custom event', eventName, eventData)
    document.dispatchEvent(
      new CustomEvent(eventName, {
        bubbles: true,
        detail: eventData
      })
    )
  }
}

export default GA4Provider
